import styled from "styled-components";
import { datastoresMenuFonts } from "styles/font-sizes";

export const StyledLabel = styled.span`
  font-size: ${datastoresMenuFonts.datastoreInstance}px;
  vertical-align: super;
`;
